var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tab',_vm._b({},'v-tab',{ ..._vm.$attrs },false),[_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }